import * as React from "react";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import Divider from "@mui/material/Divider";
import Drawer from "@mui/material/Drawer";
import IconButton from "@mui/material/IconButton";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemText from "@mui/material/ListItemText";
import MenuIcon from "@mui/icons-material/Menu";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import LocalPhoneIcon from "@mui/icons-material/LocalPhone";
import { ReactComponent as LogoSvg } from "../assets/logo.svg";
import { ReactComponent as LeafSvg } from "../assets/leaf2.svg";
import Network from "./Network";

import { trackPhoneConversion } from "../utils/googleAds";

import { useMediaQuery } from "@mui/material";
import { useTheme } from "@mui/material/styles";

import { keyframes } from "@mui/system";
import { MOBILE_NUMBER } from "../constants/contacts";
import { useNavigate } from "react-router-dom";
import { useLocation } from "react-router-dom";

const ring = keyframes`
  0% { transform: rotate(0); }
  10% { transform: rotate(15deg); }
  20% { transform: rotate(-15deg); }
  30% { transform: rotate(10deg); }
  40% { transform: rotate(-10deg); }
  50% { transform: rotate(5deg); }
  60% { transform: rotate(-5deg); }
  70% { transform: rotate(0); }
  100% { transform: rotate(0); }
`;
const goldShimmer = keyframes`
  0% {
    transform: translateX(-100%) rotate(15deg);
  }
  100% {
    transform: translateX(100%) rotate(15deg);
  }
`;
const drawerWidth = 240;
const navItems = [
  { label: "Головна", type: "scroll", target: "main" },

  {
    label: "Післяремонтне",
    type: "route",
    path: "/serviceDetails/after-repair",
  },
  {
    label: "Післяорендне",
    type: "route",
    path: "/serviceDetails/after-rent",
  },
  {
    label: "Для бізнесу",
    type: "route",
    path: "/serviceDetails/for-business",
  },

  { label: "Контакти", type: "scroll", target: "footer" },
];

export default function Header(props) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const location = useLocation();
  const { winProp } = props;
  const [mobileOpen, setMobileOpen] = React.useState(false);

  const navigate = useNavigate();

  const handleDrawerToggle = () => {
    setMobileOpen((prevState) => !prevState);
  };

  const handleHomeClick = (service) => {
    navigate(`/`);
  };
  function handleNavClick(item) {
    if (item.type === "route") {
      navigate(item.path);
      setMobileOpen(false);
      return;
    }

    if (window.location.pathname === "/") {
      scrollTo(item.target);

      if (item.target === "footer") {
        window.dispatchEvent(new CustomEvent("focus-footer"));
      }
    } else {
      navigate("/", {
        state: { scrollTo: item.target, highlight: item.target === "footer" },
      });
    }

    setMobileOpen(false);
  }
  function scrollTo(id) {
    const targetElement = document.getElementById(id);
    const navbar = document.getElementById("navbar");
    if (targetElement) {
      const top =
        targetElement.getBoundingClientRect().top +
        window.scrollY -
        navbar.clientHeight;
      window.scrollTo({ top, behavior: "smooth" });
    }
  }

  const drawer = (
    <Box
      sx={{
        textAlign: "center",
        background:
          "linear-gradient(135deg, #fffaf0 0%, #fff8dc 40%, #fffaf0 100%)",
        "&::before": {
          content: '""',
          position: "absolute",
          top: "-50%",
          left: "-50%",
          width: "200%",
          height: "200%",

          background: `
    radial-gradient(
      circle at center,
      rgba(255, 215, 0, 0.06) 0%,
      rgba(255, 199, 95, 0.10) 35%,
      rgba(184, 134, 11, 0.14) 60%,
      rgba(255, 215, 0, 0.06) 100%
    ),
    linear-gradient(
      120deg,
      transparent 0%,
      rgba(255, 215, 0, 0.04) 40%,
      rgba(255, 215, 0, 0.14) 50%,
      rgba(255, 215, 0, 0.04) 60%,
      transparent 100%
    )
  `,

          filter: "blur(28px)",
          animation: `${goldShimmer} 3s linear infinite`,
          pointerEvents: "none",
        },

        overflow: "hidden",
        height: "100%",
      }}
    >
      <Typography
        variant="h6"
        sx={{ my: 2, color: "#f5c33d", fontWeight: "bold" }}
      >
        Sweet Clean
      </Typography>
      <Divider />
      <List>
        {navItems.map((item) => (
          <ListItem key={item.label} disablePadding>
            <ListItemButton
              sx={{ textAlign: "center", color: "#5f2e20" }}
              onClick={() => handleNavClick(item)}
              selected={
                item.type === "route" && location.pathname.includes(item.path)
              }
            >
              <ListItemText primary={item.label} />
            </ListItemButton>
          </ListItem>
        ))}
      </List>
      <Divider />
      <Network />
    </Box>
  );

  const container =
    winProp !== undefined ? () => winProp().document.body : undefined;

  return (
    <Box sx={{ display: "flex" }}>
      <AppBar component="nav" id="navbar">
        <Toolbar sx={{ justifyContent: "space-between" }}>
          <Stack direction="row" spacing={2} alignItems="center">
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                cursor: "pointer",
              }}
              onClick={handleHomeClick}
            >
              <Box sx={{ display: "flex", gap: 1 }}>
                <LogoSvg style={{ width: "2rem", height: "2rem" }} />
                <Typography
                  variant="h6"
                  component="div"
                  sx={{
                    fontWeight: 700,
                    color: "#f5c33d",
                  }}
                >
                  Sweet Clean
                </Typography>
              </Box>
              <Typography
                sx={{
                  fontWeight: 300,
                  lineHeight: 1,
                  color: "#f5c33d",
                }}
              >
                ексклюзивний клінінг
              </Typography>
            </Box>
            <LeafSvg style={{ width: "3rem", height: "3rem" }} />
            <IconButton
              color="inherit"
              aria-label="open drawer"
              edge="start"
              onClick={handleDrawerToggle}
              sx={{ mr: 0, ml: "0 !important", color: "#f5c33d" }}
            >
              <MenuIcon sx={{ width: "2.5rem", height: "2.5rem" }} />
            </IconButton>
          </Stack>
          <Box>
            <a href={`tel:${MOBILE_NUMBER}`}>
              <Button
                startIcon={<LocalPhoneIcon />}
                sx={{
                  background: "#f5c33d",
                  color: "rgba(0, 0, 0, 0.84) !important",
                  display: { xs: "none", md: "inline-flex" },
                  boxShadow:
                    "0 0 5px #FFD700, 0 0 10px #AA771C, 0 0 15px #8C5802",
                }}
                 onClick={trackPhoneConversion}
              >
                Зателефонувати
              </Button>
              <IconButton
                sx={{
                  display: {
                    xs: "inline-flex",
                    md: "none",
                    background: "#f2f2e6",
                    borderRadius: "10px",
                    border: "2px solid #f5c33d",
                    boxShadow:
                      "0 0 5px #FFD700, 0 0 10px #AA771C, 0 0 15px #8C5802",
                  },
                }}
                onClick={trackPhoneConversion}
              >
                <LocalPhoneIcon
                  sx={{
                    color: "#f5c33d",
                    animation: `${ring} 1.5s ease-in-out infinite`,
                  }}
                />
              </IconButton>
            </a>
          </Box>
        </Toolbar>
      </AppBar>
      <nav>
        <Drawer
          container={container}
          variant="temporary"
          open={mobileOpen}
          onClose={handleDrawerToggle}
          ModalProps={{
            keepMounted: true,
          }}
          sx={{
            display: "block",
            "& .MuiDrawer-paper": {
              boxSizing: "border-box",
              width: drawerWidth,
              overflow: "hidden",
            },
          }}
        >
          {drawer}
        </Drawer>
      </nav>
    </Box>
  );
}
